export default __webpack_public_path__ + "static/media/galleon.3229b30b.jpg";